import axiosInstance from '@/services/interceptor.services';

export type PaymentProcessor = 'mock' | 'market_pay' | 'on_site' | 'payfast';

export interface PaymentConfig {
  processor: PaymentProcessor;
  enabled: boolean;
  displayName: string;
  publicConfig: Record<string, unknown>;
  // Omis = conserve la valeur déjà enregistrée côté serveur (pas de merge :
  // un objet fourni, même partiel, REMPLACE tous les secrets existants).
  secretConfig?: Record<string, unknown>;
}

export interface PaymentConfigResponse {
  processor: PaymentProcessor;
  enabled: boolean;
  displayName: string | null;
  publicConfig: Record<string, unknown>;
  hasSecret: boolean;
  secretPreviews: Record<string, string>;
}

export const paymentConfigService = {
  async list(storeId: string): Promise<PaymentConfigResponse[]> {
    const { data } = await axiosInstance.get(`payment-configs/${storeId}`);
    return data?.data ?? [];
  },

  async upsert(
    storeId: string,
    processor: PaymentProcessor,
    payload: Omit<PaymentConfig, 'processor'>,
  ): Promise<void> {
    await axiosInstance.put(`payment-configs/${storeId}/${processor}`, payload);
  },
};
